import axiosInstance from '@/utils/api.js'

var state = {
  freezedServiceLink: []
}

var getters = {
  FREEZED_SERVICE_LINK: (state) => {
    return state.freezedServiceLink
  }
}

var mutations = {
  SET_FREEZED_SERVICE_LINK: (state, payload) => {
    state.freezedServiceLink = payload || []
  }
}

var actions = {
  GET_FREEZED_SERVICE_LINK: async (context, payload) => {
    let result = await axiosInstance.get('/users/servicelinks/freezed?slink_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_FREEZED_SERVICE_LINK', result.data)
    }
  },
  CREATE_FREEZED_SERVICE_LINK: (context, payload) => {
    return axiosInstance.post('/users/servicelinks/freezed', payload)
  },
  UPDATE_FREEZED_SERVICE_LINK: (context, payload) => {
    return axiosInstance.put('/users/servicelinks/freezed', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/users/servicesLinkFreezed.js